import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import {
  InlineNotification,
  Loading,
  NotificationActionButton
} from 'carbon-components-react';
import Utils from 'utilities/helper.util';
import { IMPERSONATE_USER } from 'types';
const IUserGlobalHeader: React.FC<{}> = () => {
  const [impersonateUser, setIUser] = useState<any>({});
  const [userSessionTime, setUserSessionTime] = useState<string | undefined>();
  const [asTimeLeft, setAsTimeLeft] = useState<number>();
  const [secTimer, setSecTimer] = useState<number>();
  const [isIUserStopping, setIsIUserStopping] = useState<boolean>(false);

  dayjs.extend(relativeTime);
  useEffect(() => {
    const _impersonateUser: string = sessionStorage.getItem('user') || '';
    const isActive = !Utils.isEmptyStr(_impersonateUser);
    if (isActive) {
      setIUser(JSON.parse(_impersonateUser));
      const iuExpiryTime = JSON.parse(_impersonateUser).expiry;
      setUserSessionTime(iuExpiryTime);
      setAsTimeLeft(dayjs(iuExpiryTime).diff(dayjs(), 'm'));
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setSecTimer(dayjs(userSessionTime).diff(dayjs(), 's'));
    }, 1000);
    return () => clearInterval(interval);
  }, [userSessionTime]);

  useEffect(() => {
    if (secTimer) {
      if (secTimer <= 0) {
        setAsTimeLeft(0);
        stopIUserSession();
      } else {
        secTimer >= 60
          ? setAsTimeLeft(dayjs(userSessionTime).diff(dayjs(), 'm'))
          : setAsTimeLeft(secTimer);
      }
    }
  }, [userSessionTime, secTimer]);

  const stopIUserSession = async () => {
    setIsIUserStopping(true);
    sessionStorage.removeItem(IMPERSONATE_USER.SESSION_NAME);
    window.location.reload();
  };

  return (
    <React.Fragment>
      <InlineNotification
        className="impersonateUserGlobalHeader"
        hideCloseButton
        lowContrast
        kind="info"
        iconDescription=""
        title="Impersonating"
        subtitle={
          <React.Fragment>
            <span>{impersonateUser?.User?.email} </span>
            {asTimeLeft && (
              <span>
                (
                {` ${asTimeLeft} ${
                  secTimer && secTimer <= 60 ? 'sec' : 'min'
                } left `}
                )
              </span>
            )}
          </React.Fragment>
        }
        actions={
          <NotificationActionButton
            disabled={isIUserStopping}
            onClick={stopIUserSession}
          >
            {isIUserStopping ? (
              <Loading
                small
                description="Active loading indicator"
                withOverlay={false}
              />
            ) : (
              'Stop'
            )}
          </NotificationActionButton>
        }
      />
    </React.Fragment>
  );
};

export default React.memo(IUserGlobalHeader);
